import { render } from "./Image.vue?vue&type=template&id=a4839320&scoped=true"
import script from "./Image.vue?vue&type=script&lang=ts"
export * from "./Image.vue?vue&type=script&lang=ts"

import "./Image.vue?vue&type=style&index=0&id=a4839320&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-a4839320"

export default script